module.exports = __webpack_public_path__ + "img/room.0bcee941.svg";